import { currentRoute, getBreadcrumb } from '@/router';
import { dashboard, loadDashboard, loadNews } from '@/store/dashboard';
import { loadOrders } from '@/store/orders';
import { runSearch } from '@/store/catalog';

export function Header() {
  const route = currentRoute.value;
  const partner = dashboard.value;

  async function refresh() {
    if (route === 'search') return runSearch();
    if (route === 'orders') return loadOrders();
    return Promise.all([loadDashboard(), loadNews()]);
  }

  return (
    <header class="page-header">
      <div class="breadcrumbs">{getBreadcrumb(route)}</div>
      <div class="header-actions">
        <div class="header-user-card">
          <div class="header-user-avatar">
            <i class="fa-solid fa-user" />
          </div>
          <div class="header-user-info">
            <div class="header-user-login">{partner?.login ?? '—'}</div>
            <div class="header-user-partner">{partner?.name ?? ''}</div>
          </div>
        </div>
        <button type="button" onClick={refresh}>
          Обновить данные
        </button>
      </div>
    </header>
  );
}
